import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {auth} from "../firebase";

function LoginPage() {
    const navigate = useNavigate();

    const [data, setData] = useState({
        email: "",
        password: "",
    })

    const handleChange = name => event => {
        const value = event.target.value
        setData({...data, [name]: value })
    }

    const login = (e) => {
        e.preventDefault()

        auth.signInWithEmailAndPassword(data.email, data.password).then((authUser) => {
            if (authUser) {
                navigate(`/dashboard/${authUser.user.uid}/overview`)
            }
        }).then((err) => {
            console.error(err)
        })
    }

    return (
        <section className="contact section-padding">
            <div className="w-layout-blockcontainer container w-container">
                <div data-w-id="44130a78-0466-a8d4-6bde-6b77b0115ef6"
                     className="content-wrapper contact">
                    <div className="section-title center">
                        <p className="label">Login</p>
                        <div className="title center">
                            <h2 className="heading-2 text-align-center">Let's Get Started</h2>
                        </div>
                    </div>
                    <div className="single-contact-address stoke">
                        <div className="contact-form-wrapper">
                            <div className="form-wrapper w-form">
                                <form id="wf-form-Contact-Form" className="contact-form space-y-6" onSubmit={login}>
                                    <div className="form-item-wrapper">
                                        <label htmlFor="Email" className="body-text-16 text-neutral-01">
                                            Email *
                                        </label>
                                        <input className="input-item body-text-16 w-input" maxLength="256" name="email"
                                               type="email" id="Email" required value={data.email} onChange={handleChange("email")} />
                                    </div>
                                    <div className="form-item-wrapper">
                                        <label htmlFor="Email" className="body-text-16 text-neutral-01">Password *</label>
                                        <input className="input-item body-text-16 w-input" name="password" type="password"
                                               id="Email" required value={data.password} onChange={handleChange("password")} />
                                    </div>
                                    <input type="submit" className="submit-button bg-theme-color-01 button-text w-button"
                                           value="Login"/>
                                    <div className="flex justify-between">
                                        <Link to="/forgot-password">
                                            <p className="label">I forgot my password</p>
                                        </Link>
                                        <Link to="/">
                                            <p className="label">Go To Homepage</p>
                                        </Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default LoginPage;